var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8256_46756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5221 6.18547C23.3864 5.67489 23.119 5.20889 22.7466 4.83413C22.3743 4.45936 21.91 4.18897 21.4003 4.05002C19.5239 3.54547 12.0239 3.54547 12.0239 3.54547C12.0239 3.54547 4.52393 3.54547 2.64756 4.05002C2.13786 4.18897 1.67358 4.45936 1.30121 4.83413C0.928842 5.20889 0.661431 5.67489 0.525744 6.18547C0.0239258 8.07002 0.0239258 12 0.0239258 12C0.0239258 12 0.0239258 15.93 0.525744 17.8146C0.661431 18.3251 0.928842 18.7911 1.30121 19.1659C1.67358 19.5407 2.13786 19.8111 2.64756 19.95C4.52393 20.4546 12.0239 20.4546 12.0239 20.4546C12.0239 20.4546 19.5239 20.4546 21.4003 19.95C21.91 19.8111 22.3743 19.5407 22.7466 19.1659C23.119 18.7911 23.3864 18.3251 23.5221 17.8146C24.0239 15.93 24.0239 12 24.0239 12C24.0239 12 24.0239 8.07002 23.5221 6.18547Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56934 15.5687V8.4314L15.8421 12L9.56934 15.5687Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8256_46756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#fff"
  })))));
};
export default SvgYoutube;